import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  inject,
  input,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SystemTag } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalFooterComponent } from '../modal-footer/modal-footer.component';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { ModalComponent } from '../modal.component';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    ModalComponent,
    ModalContentComponent,
    ModalFooterComponent,
    TranslatePipe
  ]
})
export class ConfirmationDialogComponent {
  private ngbActiveModal = inject(NgbActiveModal);

  readonly message = input<string>(undefined);
  readonly acknowledge = input(false);
  readonly innerHTML = input(false);
  readonly titleMessage = input<string>(undefined);
  readonly okButtonMessage = input('general.ok');
  readonly cancelButtonMessage = input('general.cancel_a');
  readonly titleValue = input(null);
  readonly messageValue = input<unknown>(null);
  readonly systemTags = input<SystemTag[]>(undefined);

  okAction() {
    this.ngbActiveModal.close();
  }

  cancelAction() {
    this.ngbActiveModal.dismiss();
  }

  public get isProspectOfflineSales() {
    return this.systemTags()?.includes(
      SystemTag.OFFLINE && SystemTag.SALES_PROSPECT
    );
  }
}
